import { render, staticRenderFns } from "./BookKeeping.vue?vue&type=template&id=07bccfa3&scoped=true"
import script from "./BookKeeping.vue?vue&type=script&lang=js"
export * from "./BookKeeping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bccfa3",
  null
  
)

export default component.exports